import { useMediaQuery } from '@mui/material';

// no-dd-sa:javascript-code-style/parameter-name
const withMediaQuery = () => (Component) => (props) => {
  const mediaQuery = {};
  mediaQuery.isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  mediaQuery.isDesktop = useMediaQuery((theme) => theme.breakpoints.up('md'));
  mediaQuery.isDownSM = useMediaQuery((theme) => theme.breakpoints.down('md'));
  mediaQuery.isDownMD = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  return <Component mediaQuery={mediaQuery} {...props} />;
};

export default withMediaQuery;
